import React, { useEffect, useState } from "react";

import { useCookies } from "react-cookie";
import * as S from "./styled";

import PopupImage01 from "../../assets/images/popup/popupImage01.webp";

export default function Popup() {
  const [open, setOpen] = useState(true); // 닫기버튼을 눌렀는가
  const [checked, setChecked] = useState(false); // 체크박스를 체크했는가
  const [hasCookie, setHasCookie] = useState(true); // 쿠키가 저장되어있는가
  // (초기값을 false로 하면, 쿠키가 있어도 처음에 잠깐 나타남.)
  const [cookies, setCookies] = useCookies(); // 쿠기에 저장되는 내용

  // 닫기 버튼이 click 됐을 때
  const handleClose = () => {
    setOpen(false);
  };

  // 체크박스가 change 됐을 때
  const handleChange = (e: any) => {
    const changed = e.target.checked;
    changed ? setChecked(true) : setChecked(false);
  };

  // 쿠키의 유효기한을 지정하는 함수
  const getExpiredDate = (days: number) => {
    const date = new Date(); // 현재 시간을 받아온다
    date.setDate(date.getDate() + days);
    // 현재시간의 날짜에 days 만큼 더하여 유효기간을 지정
    return date;
  };

  // 페이지 열면 바로 쿠키 유무 확인
  useEffect(() => {
    if (cookies["POP_Cookie"]) {
      // POP_Cookie라는 쿠키가 있어?
      setHasCookie(true);
    } else setHasCookie(false); // 없어?
  }, []);

  // 닫기 버튼을 누를 때마다 실행될 코드.
  useEffect(() => {
    // 체크되지 않은 상태에서 모달을 닫을 경우
    if (!checked && !open) {
      return;
    }
    // 체크된 상태에서 모달을 닫을 경우
    if (checked && !open) {
      //쿠키를 저장하는 핵심 코드
      const expires = getExpiredDate(1);
      setCookies("POP_Cookie", true, { path: "/", expires });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <S.PopupWrapper>
      {!hasCookie ? (
        <S.PopupWrapBg className={` ${open ? "" : "none"}`}>
          <S.PopupWrap>
            {/* <p onClick={handleClose}>이걸 클릭하면 꺼집니다</p> */}
            <S.PopupImageWrapper>
              <S.PopupImageWrap>
                <img src={PopupImage01} alt={"팝업"} />
              </S.PopupImageWrap>
              {/* <S.PopupImageWrap>
                <img src={PopupImage02} alt={"팝업"} />
              </S.PopupImageWrap> */}
            </S.PopupImageWrapper>

            <S.PopupButtonWrap>
              <S.PopupInputWrap>
                <S.PopupInput
                  type="checkbox"
                  id="checkbox"
                  onChange={handleChange}
                />
                <S.PopupLabel htmlFor="checkbox">
                  오늘 하루 더이상 보지 않기
                </S.PopupLabel>
              </S.PopupInputWrap>
              <S.PopupCloseButton onClick={handleClose}>
                닫기
              </S.PopupCloseButton>
            </S.PopupButtonWrap>
          </S.PopupWrap>
        </S.PopupWrapBg>
      ) : (
        ""
      )}
    </S.PopupWrapper>
  );
}
